//导入View支持
import Vue from 'vue'

//导入iview组件库支持
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

//导入路由支持
import VueRouter from 'vue-router';
Vue.use(VueRouter);

//兼容IE ES6支持
import 'babel-polyfill'

import strUtils from './utils/stringutil';
Vue.prototype.strUtils = strUtils;

import axios from './utils/axiosconfig'

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

if (!strUtils.isEmpty(localStorage.token)) {
  axios.defaults.headers.common['Authorization'] = localStorage.token;
}

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = "http://localhost:8080/mqms-server/webapi";
  // axios.defaults.baseURL = "http://172.20.242.242:8080/mqms-server/webapi";
  // axios.defaults.baseURL = "http://192.168.202.25:8080/mqms-server/webapi";
}
else if (process.env.NODE_ENV === 'production') {
  if (window.location.host.indexOf('192.168.202.25') > -1) {
    axios.defaults.baseURL = "http://192.168.202.25:8080/mqms-server/webapi";
  }
  else {
    axios.defaults.baseURL = "http://218.4.136.119:8100/mqms-server/webapi";
  }
}

Vue.prototype.$axios = axios;
Vue.prototype.$http = axios.$http;

//导入主页面
import App from './App.vue'

import login from './views/frame/login'
import main from './views/frame/main'
import dict from './views/frame/dict'
import user from './views/frame/user'
import projectattention from './views/project/projectattention'
import projectall from './views/project/projectall'
import project from './views/project/project'
import projectoverview from './views/project/projectoverview'
import appmanage from './views/project/appmanage'
import appmanagev2 from './views/project/appmanagev2'
import appdist from './views/project/appdist'
import appdistv2 from './views/project/appdistv2'
import ipadistdetail from './views/project/ipadistdetail'
import apkdistdetail from './views/project/apkdistdetail'
import h5distdetail from './views/project/h5distdetail'
import dashboard from './views/project/dashboard'
import modalsample from './views/sample/modalsample'
import ipaexpire from './views/project/ipaexpire'
import projectplan from './views/project/projectplan'
import menu from './views/frame/menu'
import updatepub from './views/frame/updatepub'
import iosmobileprovisionmange from './views/frame/iosmobileprovisionmange'
import projecttags from './views/project/projecttags'
import datacopy from './views/sample/datacopy'
import tagsquery from './views/project/tagsquery'
import appquery from './views/project/appquery'
import projdownloadpage from './views/project/projectdownloadpage'
import archivesearch from './views/project/archivesearch'

// 发布管理相关页面
import releasemanage from './views/project/releasemanage'
import releasemanageForm from './views/project/releasemanage_form'
import releasemanageDetail from './views/project/releasemanage_detail'
import releasemanageExamine from './views/project/releasemanage_examine'


Vue.config.productionTip = false

const Routers = [
  {
    path: '/index',
    redirect: '/login'
  },
  {
    path: '/projdownloadpage',
    component: projdownloadpage
  },
  {
    path: '*',
    redirect: '/index'
  }, 
  {
    path: '/login',
    component: login
  }, 
  {
    path: '/main',
    component: main,
    children: [
      {
        path: "/projectall",
        component: projectall
      },{
        path: "/appquery",
        component: appquery
      },
      {
        path: "/dict",
        component: dict
      },
      {
        path: "/tagsquery",
        component: tagsquery
      },
      {
        path: "/user",
        component: user
      },
      {
        path: '/projectattention',
        component: projectattention
      },
      {
        path: '/dashboard',
        component: dashboard
      },
      {
        path: '/ipaexpire',
        component: ipaexpire
      },
      {
        path: '/menu',
        component: menu
      },
      {
        path: '/updatepub',
        component: updatepub
      },
      {
        path: '/iosmobileprovisionmange',
        component: iosmobileprovisionmange
      },
      {
        path: '/archivesearch',
        component: archivesearch
      },
      {
        path: '/vreleasemanage',
        component: releasemanage,
        name: "vreleasemanage"
      },
      {
        path: '/vreleasemanage/formrequest',
        component: releasemanageForm,
        name:"vreleasemanageformadd"
      },
      {
        path: '/vreleasemanage/formrequest/:id',
        component: releasemanageForm,
        name:"vreleasemanageformupdate"
      },
      {
        path: '/vreleasemanage/formrequestdetail/:id',
        component: releasemanageDetail,
        name:"formrequestdetail"
      },
      {
        path: '/vreleasemanage/formrequestexamine/:id',
        component: releasemanageExamine,
        name:"formrequestexamine"
      }
    ]
  }, 
  {
    path: '/project/:projectguid',
    component: project,
    children: [
      {
        path: "/projectoverview/:projectguid",
        component: projectoverview,
        name: "projectoverview"
      },
      {
        path: "/appmanage/:projectguid",
        component: appmanage
      },
      {
        path: "/appmanagev2/:projectguid",
        component: appmanagev2
      },
      {
        path: "/appdistv2/:projectguid",
        component: appdistv2
      },
      {
        path: "/appdist/:projectguid",
        component: appdist
      },
      {
        path: "/projectplan/:projectguid",
        component: projectplan
      },
      {
        path: "/projecttags/:projectguid",
        component: projecttags
      }
    ]
  }, 
  {
    path: '/ipadistdetail/:id',
    component: ipadistdetail
  }, 
  {
    path: '/apkdistdetail/:id',
    component: apkdistdetail
  }, 
  {
    path: '/h5distdetail/:id',
    component: h5distdetail
  },
  {
    path: '/modalsample',
    component: modalsample
  },
  {
    path: '/datacopy',
    component: datacopy
  }
];

const RouterConfig = {
  // 使用 HTML5 的 History 路由模式
  // mode: 'history',
  routes: Routers
};

const router = new VueRouter(RouterConfig);


let _current_user_info = null;
Vue.prototype.setCurrentUserInfo = function(user){ _current_user_info = user}
Vue.prototype.getCurrentUserInfo = () => _current_user_info;

new Vue({
  render: h => h(App),
  router: router,
}).$mount('#app')

